import React from 'react';

function HeroSection() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-glow" aria-hidden="true" />
      <div className="container hero-content">
        <p className="eyebrow"><span className="eyebrow-dot" /> Satu nama, empat inisiatif</p>
        <h1 id="hero-title">candradimuka.id</h1>
        <p className="hero-copy">
          Training, digital, dan pemberdayaan diri. Empat inisiatif di bawah satu nama.
        </p>
        <div className="hero-actions">
          <a className="button button-primary" href="#portofolio">
            Lihat Portofolio <span aria-hidden="true">↗</span>
          </a>
          <a className="button button-ghost" href="#kontak">Hubungi Kami</a>
        </div>
        <div className="hero-note">
          <span aria-hidden="true">✳</span> Ruang untuk bertumbuh, berkarya, dan berdampak.
        </div>
      </div>
      <div className="hero-orbit orbit-one" aria-hidden="true" />
      <div className="hero-orbit orbit-two" aria-hidden="true" />
    </section>
  );
}

export default HeroSection;